module.exports = "file3";


/*****************
 ** WEBPACK FOOTER
 ** ./parsing/extract-require/folder/file3.js
 ** module id = 4
 ** module chunks = 0
 **/